
import React, {Component} from 'react'
import HelpEl from './el/HelpEl'

export default (props) => {
    return (<HelpEl/>)
}



// WEBPACK FOOTER //
// ./src/help/Help.js